/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Grid,
  Radio,
  Table,
  Message
} from "semantic-ui-react";
import * as yup from "yup";
import moment from "moment";
import { withFormik, Field as Fieldmik, FieldArray, Form as Formiker } from "formik";
import { REQUIRED } from "../../utils/validationConstant";

import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import { MyInput, MyNormalInput } from "../dynamicComponent/myInputs";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import { data } from "jquery";
// import { Grid } from "react-bootstrap";
import SearchDropdown from "./searchDropdown";
import cogoToast from "cogo-toast";
import { YYYYMMDD_HHMM } from '../../utils/constants/date-formats'

let errorMessage = ''

const ClubBooking = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  booking,
  resetForm,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [routeSelected, setRouteSelected] = useState([]);
  const [bookingIdsSelected, setBookingIdsSelected] = useState([]);
  const [order, setOrder] = useState([]);
  const [clubErrorMessage, setClubErrorMessage] = useState('');
  useEffect(() => {
    setOrder(booking);
    setBookingData(booking);
    setVehicleType(props.requiredVehicleType);
    getOwnershipType();
    getOwnVendors();
    checkClubIssues()
  }, [booking, order, clubErrorMessage]);

  const checkClubIssues = () => {
    let FTLBookings = order?.filter((item) => item?.booking_delivery?.service_type_id === 1)
    if(FTLBookings.length > 0){
      setClubErrorMessage(t('error_msg.ftl_clubbing') || "Cannot club FTL bookings")
    } else {
      setClubErrorMessage('')
    }
  }

  const setBookingData = (bookingSelected) => {
    let bookingIDS = [];
    errorMessage = ''
    if (bookingSelected?.length > 0) {
      let route = bookingSelected.map((item, index) => {
        bookingIDS.push(item.booking_id);
        if(bookingSelected[0]?.booking_branch != item?.booking_branch) {
          errorMessage = t('error_msg.different_branch') || "Booking branches should be same"
        }

        return {
          key: index + 1,
          text:
            item?.source &&
            item?.source != "NA" &&
            item?.destination &&
            item?.destination != "NA"
              ? item.source.concat("-", item.destination)
              : item?.source && item?.source != "NA"
              ? item.source
              : item?.destination && item?.destination != "NA"
              ? item.destination
              : "",
          value: item.route_code,
        };
      });

      setRouteSelected(route);
      setBookingIdsSelected(bookingIDS);
    }
  };

  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
    if (values.vendor) handleSubmit();
  };

  const removeBooking = (event, item, index) => {
    let bookings = order;
    bookings.splice(index, 1);
    setBookingData(bookings);
    setOrder(bookings);
    checkClubIssues()
  };

  const [ownVendor, setOwnVendor] = useState([]);
  const getOwnVendors = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`,
      payload: {vendorOwnershipType: "1"}
    }).then((result) => {
      let tempown = [];
      let vendorData = result.data.resultSet;
      for (let index = 0; index < vendorData.length; index++) {
        if (vendorData[index].vendorOwnershipType == 1) {
          tempown.push(vendorData[index]);
        }
      }
      tempown = vendorData.map((item, index) => {
        return {
          key: index + 1,
          text: item.transporterName,
          value: item.transporterMasterId,
          raw: { ...item },
        };
      });
      setOwnVendor(tempown);
    });
  };

  const [vendorSearchData, setVendorSearchData] = useState([]);
  const handleVendorSearch = (e, data) => {
    if (data.searchQuery) {
      let searchTerm = data.searchQuery;
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`,
        payload: { searchTerm: searchTerm },
      }).then((result) => {
        let tempown = [];
        let vendorData = result.data.resultSet;
        for (let index = 0; index < vendorData.length; index++) {
          if (
            vendorData[index].vendorOwnershipType == 0 ||
            vendorData[index].vendorOwnershipType == null
          ) {
            tempown.push(vendorData[index]);
          }
        }
        let tempVendorData = [];
        if (tempown.length > 0) {
          tempown.map((object, index) => {
            let temp = {};
            temp.raw = { ...object };
            temp.key = object.transporterMasterId;
            temp.text = object.transporterName;
            temp.value = object.transporterMasterId;
            return (tempVendorData[index] = temp);
          });
        }
        setVendorSearchData(tempVendorData);
      });
    }
  };

  const [ownershipType, setOwnershiptype] = useState([]);
  const getOwnershipType = () => {
    /* setLoading(true); */
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        //setLoading(false);
        let ownership = res.data.resultSet;
        setOwnershiptype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.vehicleOwnershipTypeId,
              text: item.vehicleOwnershipTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Modal
        /* style={{ overflow: "inherit" }} */
        open={modalOpen}
        onClose={() => {
          resetForm();
          handleClose();
        }}
        closeOnDimmerClick={false}
        size="large"
        trigger={
          <Button
            disabled={booking?.length > 1 ? false : true}
            type="button"
            onClick={handleOpen}
            size="mini"
            color="yellow"
            className=" m-2 w3-hover-yellow"
            circular
          >
            {"Club"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            {t('title') || 'Club Request'}
            <i onClick={handleClose} className="fas fa-times"></i>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
          {clubErrorMessage && <Message warning>
            <Message.Header>{clubErrorMessage}</Message.Header>
          </Message>}
            <Table compact celled definition>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell className="no-border-top" />
                  <Table.HeaderCell>{t("table.headers.booking_number") || 'Booking Number'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.booking_branch") || 'Booking Branch'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.booking_date") || 'Booking Date'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.route") || 'Route'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.source") || 'Source'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.destination") || 'Destination'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.status") || 'Status'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.pending_vehicles") || 'Pending Vehicles'}</Table.HeaderCell>
                  <Table.HeaderCell>{t("table.headers.vehicle_type") || 'Vehicle type'}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {order?.length > 0 &&
                  order.map((item, index) => {
                    return (
                      <>
                        <Table.Row>
                          <Table.Cell collapsing>
                            <Icon
                              name="minus circle"
                              disabled={order.length > 2 ? false : true}
                              onClick={(e) => {
                                removeBooking(e, item, index);
                              }}
                            />
                          </Table.Cell>
                          <Table.Cell>{item.booking_number}</Table.Cell>
                          <Table.Cell>{item.booking_branch}</Table.Cell>
                          <Table.Cell>{item.booking_date}</Table.Cell>
                          <Table.Cell>{item.route_code}</Table.Cell>
                          <Table.Cell>{item.source}</Table.Cell>
                          <Table.Cell>{item.destination}</Table.Cell>
                          <Table.Cell>{item.status}</Table.Cell>
                          <Table.Cell>{item.pending_vehicles}</Table.Cell>
                          <Table.Cell>
                            {item?.vehicle_type?.vehicle_type
                              ? item.vehicle_type.vehicle_type
                              : ""}
                          </Table.Cell>
                        </Table.Row>
                      </>
                    );
                  })}
              </Table.Body>
            </Table>

            <div className="ui form">
              <Formiker>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 width-adjust-100cent display-flex-center-justify-spacebtwn">
                      <span className="required-form-element">{t("form.route_code.label") || "Route"}</span>
                      <Radio
                        toggle
                        name="gridView"
                        checked={props.toggle}
                        onChange={(name) => {
                          setFieldValue("route_toggle", !values.route_toggle);
                          setFieldValue("booking_ids", bookingIdsSelected);
                        }}
                      />
                    </label>
                    {values.route_toggle ? (
                      <SearchDropdown
                        setField={(name, value) => {
                          setFieldValue(
                            "route_code",
                            value.raw ? value.raw.routeCode : ""
                          );
                          setFieldValue("booking_ids", bookingIdsSelected);
                        }}
                        placeholder={""}
                        name="route_code"
                        masterRoute="routeMaster"
                        masterRouteKey="routeMasterId"
                        masterRouteName="routeName"
                        className="ui fliud input"
                        fieldName="route_code"
                        error={
                          touched.route_code && errors.route_code && values.route_code == ''
                            ? true
                            : false
                        }
                      />
                    ) : (
                      <Dropdown
                        selection
                        name="route_code"
                        style={{ width: "100%" }}
                        onChange={(e, data) => {
                          setFieldValue("route_code", data.value);
                          setFieldValue("booking_ids", bookingIdsSelected);
                        }}
                        placeholder={"Route"}
                        options={routeSelected}
                        error={
                          touched.route_code && errors.route_code && values.route_code == ''
                            ? true
                            : false
                        }
                      />
                    )}
                    { errors.route_code && errors.route_code && values.route_code == ''? (
                            <div className="error-msg">
                              {t(
                                `form.route_code.error_msg`
                              ) || errors.route_code}
                            </div>
                          ) : null}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 required-form-element">
                      {t("form.vehicle_type_id.label") || "Vehicle Type"}
                    </label>
                    <Dropdown
                      selection
                      name="vehicle_type_id"
                      style={{ width: "100%" }}
                      onChange={(e, data) => {
                        setFieldValue("vehicle_type_id", data.value);
                        setFieldValue("booking_ids", bookingIdsSelected);
                      }}
                      placeholder={"Vehicle Type"}
                      options={vehicleType}
                      error={
                        touched.vehicle_type_id && errors.vehicle_type_id && values.vehicle_type_id == ''
                          ? true
                          : false
                      }
                    />
                    {touched.vehicle_type_id && errors.vehicle_type_id && values.vehicle_type_id == '' ? (
                            <div className="error-msg">
                              {t(
                                `form.vehicle_type_id.error_msg`
                              ) || errors.vehicle_type_id}
                            </div>
                          ) : null}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 required-form-element">
                      {t("form.ownership_type_id.label") || "Ownership Type"}
                    </label>
                    <Dropdown
                      clearable
                      name="ownership_type_id"
                      style={{ width: "100%", fontWeight: "normal" }}
                      search
                      selection
                      placeholder={"Ownership Type"}
                      onChange={(name, data) => {
                        setFieldValue("ownership_type_id", data.value);
                        setFieldValue("booking_ids", bookingIdsSelected);
                      }}
                      options={ownershipType}
                      error={
                        touched.ownership_type_id && errors.ownership_type_id && values.ownership_type_id == ''
                          ? true
                          : false
                      }
                    />
                    {touched.ownership_type_id && errors.ownership_type_id && values.ownership_type_id == '' ? (
                            <div className="error-msg">
                              {t(
                                `form.ownership_type_id.error_msg`
                              ) || errors.ownership_type_id}
                            </div>
                          ) : null}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 required-form-element">
                      {t("form.vendor_id.label") || "Vendor"}
                    </label>
                    {values?.ownership_type_id == 1 ? (
                      <Dropdown
                        name="vendor_id"
                        clearable
                        style={{ width: "100%", fontWeight: "normal" }}
                        search
                        selection
                        placeholder={"Select Vendor"}
                        onChange={(name, data) => {
                          setFieldValue("vendor_id", data.value);
                          setFieldValue("booking_ids", bookingIdsSelected);
                        }}
                        options={ownVendor}
                        error={
                          touched.vendor_id && errors.vendor_id && values.vendor_id == ''
                            ? true
                            : false
                        }
                      />
                    ) : (
                      <>
                        <Dropdown
                          name="vendor_id"
                          selection
                          search
                          clearable
                          style={{ width: "100%" }}
                          onSearchChange={handleVendorSearch}
                          onChange={(name, data) => {
                            setFieldValue("vendor_id", data.value);
                            setFieldValue("booking_ids", bookingIdsSelected);
                          }}
                          // search
                          // onChange={handleChange}
                          options={vendorSearchData}
                          noResultsMessage="Search for Result"
                          placeholder={"Select Vendor"}
                          error={
                            touched.vendor_id && errors.vendor_id && values.vendor_id == ''
                              ? true
                              : false
                          }
                        />
                      </>
                    )}
                    {touched.vendor_id && errors.vendor_id && values.vendor_id == '' ? (
                            <div className="error-msg">
                              {t(
                                `form.vendor_id.error_msg`
                              ) || errors.vendor_id}
                            </div>
                          ) : null}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 required-form-element">
                      {/* {"Final Rate"} */}
                      {t('form.freight_rate.label') || "Final Rate"}
                    </label>
                    <input
                      type="number"
                      min="1"
                      name="freight_rate"
                      className=""
                      defaultValue={1}
                      //min={1}
                      onChange={(event, data) => {
                        setFieldValue("freight_rate", event.target.value);
                      }}
                      error={
                        values.freight_rate == ''
                          ? true
                          : false
                      }
                    />
                    {values.freight_rate == '' ? (
                            <div className="error-msg">
                              {t(
                                `form.freight_rate.error_msg`
                              ) || errors.freight_rate}
                            </div>
                          ) : null}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-inline">
                    <label className="labelName small m-2 required-form-element">
                      {t("form.required_on.label")  || "Vehicle Requirement Date"}
                    </label>
                    <DateData
                      name="required_on"
                      autoComplete="off"
                      showTimeSelect
                      timeFormat="HH:mm"
                      popperClassName="dateTime"
                      dateFormat="dd/MM/yyyy HH:mm"
                      timeIntervals={5}
                      customInput={
                        <FormUi.Input
                          icon="time"
                          className="dateWidth"
                          iconPosition="left"
                        />
                      }
                      error={
                        touched.required_on && errors.required_on && values.required_on == ''
                          ? true
                          : false
                      }
                    />
                    {touched.required_on && errors.required_on && values.required_on == '' ? (
                            <div className="error-msg">
                              {t(
                                "form.required_on.error_msg"
                              ) || errors.required_on}
                            </div>
                          ) : null}
                  </div>
                </div>
              </div>
              </Formiker>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <center>
            {/* {isSubmitting ? "Loading..." : ""} */}
            <Button
              type="submit"
              onClick={handleSubmit}
              // disabled={isSubmitting || values.vendor ? false : true}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {"Submit"}
            </Button>
            <Button
              type="button"
              onClick={() => {
                resetForm();
                handleClose();
              }}
              // disabled={isSubmitting || values.vendor ? false : true}
              size="mini"
              className="w3-white w3-round w3-hover-white"
            >
              {"Cancel"}
            </Button>
          </center>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalClub = withFormik({
  mapPropsToValues(props) {
    return {
      route_toggle: false,
      route_code: "",
      route_name: "",
      freight_rate: 1,
      required_on: "",
      vehicle_type_id: "",
      vehicle_type_name: "",
      ownership_type_id: "",
      vendor_id: "",
      vendor_name: "",
      booking_ids: [],
    };
  },
  validationSchema: yup.object().shape(
    {
      booking_ids: yup.string().required(REQUIRED || "required"),
      route_code: yup.string().required(REQUIRED || "required"),
      required_on: yup.date().required(REQUIRED || "required"),
      vendor_id: yup.string().required(REQUIRED || "required"),
      ownership_type_id: yup.string().required(REQUIRED || "required"),
      vehicle_type_id: yup.string().required(REQUIRED || "required"),
      freight_rate: yup.number().required(REQUIRED || "required"),
    },
    []
  ),
  handleSubmit(values, { setSubmitting, props }) {
    let payloadData = values;
    
    if( errorMessage != '') {
      cogoToast.error(errorMessage)
      return
    }

    payloadData.required_on = moment(payloadData.required_on).format(
      YYYYMMDD_HHMM
    );
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/bookings/club/initiate`,
      payload: { ...payloadData },
    })
      .then((res) => {
        setSubmitting(false);
        // console.log(res);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        // props.reFetchOrder();
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.error)
          cogoToast.error(err?.response?.data?.error);

        if (err?.response?.data?.message?.length > 0) {
          // console.log(
          //   "typeof err.response.data.messagetypeof err.response.data.messagetypeof err.response.data.message"
          // );
          // console.log(typeof err.response.data.message);
          if (typeof err.response.data.message === "string")
            cogoToast.error(err.response.data.message, {
              hideAfter: 8,
              position: "top-right",
            });
          else
            err.response.data.message.forEach((element) => {
              cogoToast.error(element, { hideAfter: 8, position: "top-right" });
            });
        }
      });
  },
})(ClubBooking);

const mapStateToProps = ({ permissions, auth }) => {
  return {
    permissions,
    auth,
  };
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("club_bookings")(FormikModalClub)
);
